export default {
  // Onboarding walkthrough copy. Which steps appear is decided by services/onboardingTour.ts from the
  // tenant's feature-sets and the user's permissions. Only the content lives here.
  //
  // Steps are grouped into chapters: a chapter is one feature, and anyone who does not use it skips
  // the whole thing at once. Chapter names live under `chapter.*`.
  //
  // On tone: short main clauses, no em dashes, no colon constructions. Whoever is reading this does
  // not know the product yet and is reading in passing. One sentence more beats one nested sentence.
  action: {
    begin: "Start the tour",
    later: "Later",
    next: "Next",
    back: "Back",
    replay: "Watch again",
    skip: "Skip",
    finishSteps: "Almost there",
    done: "Get started",
  },
  progress: "Step {current} of {total}",
  aria: {
    dialog: "Onboarding tour",
  },
  // Labels for the clip's playback controls. Screen readers only, on screen these are icons and "2×".
  video: {
    back: "Back 5 seconds",
    forward: "Forward 5 seconds",
    speed: "Toggle playback speed",
  },
  welcome: {
    title: "Welcome to Lewara, {name}!",
    text: "Good to have you here. A few short videos show you how Lewara works, so you can get going right away.",
    length: "{count} short videos, about {minutes} minutes",
  },
  outro: {
    eyebrow: "All done",
    title: "You are ready to go",
    text: "That was the essentials. The best place to start is your master data. You can watch the tour again whenever you like.",
    // Caption under the short clip that shows exactly this click.
    hint: "Top right, in the help menu",
  },
  // Collective hint at the end, shown only when the tenant is missing at least one feature-set.
  // Deliberately generic: some come with a higher tier, others are sold as add-ons.
  upsell: {
    text: "More features are available in the higher plans and as add-ons.",
    cta: "Change plan",
  },
  chapter: {
    basics: "Master data",
    projects: "Projects",
    hourlywagereport: "[[Hwr.pl]]",
    constructionreport: "[[Cr.pl]]",
    planning: "Personnel planning",
    costs: "Cost analysis",
    invoicing: "Invoicing",
  },
  step: {
    stammdaten: {
      title: "Set it up once, use it everywhere",
      text: "You add your employees, materials, machines and categories in one place. After that you can pick them anywhere. In projects, in reports and on invoices.",
    },
    projekt: {
      title: "Everything runs through the project",
      text: "A project holds the order, the customer and the dates. You also assign the employees, machines and materials it needs. That is exactly what your team gets to choose from on site.",
    },
    stundenlohnbericht: {
      title: "Capture what gets billed",
      text: "Each area has its own tab. Personnel, machines, material and additional efforts. The hours are added up for you. You print the finished report as a PDF and have the customer sign it.",
    },
    bautagesbericht: {
      title: "Record the day on site",
      text: "Here you enter shifts, crew, machines and anything out of the ordinary. Lewara fetches the weather for the site address. At three times of day, as an acceptance inspection asks for, and hour by hour over the whole shift.",
    },
    personalplanung: {
      title: "Who is where, and when",
      text: "Just drag an employee onto a project. Double bookings and absences are colour coded, and you can see capacity right below. So you never plan in someone who is not there.",
    },
    nachkalkulation: {
      title: "Keep an eye on costs",
      text: "Every report you capture is booked onto its project automatically. The heatmap, the trend and the analysis show where the money goes and how your margin is developing. You do not have to wait for the final invoice.",
    },
    abrechnung: {
      title: "Reports become an invoice",
      text: "Pick the project and the period, tick the reports and you are done. The wizard builds an invoice with your logo, broken down into personnel, machines and material. As a PDF, ready to send.",
    },
  },
}
